<template>
  <page-template>

    <board :is-fold="isFold"
           :http-options="httpOptions"
           :config="config"
           :disabled-play-button="false"
           :play-button-function="callModalSignupConfirm"
           :disabled-modify-button="true"/>

  </page-template>
</template>

<script>
import config from './Config';
import CommonBoardItems from '../CommonBoardItems';

export default {
  name: 'BoardSignupManagement',
  mixins: [CommonBoardItems],
  data() {
    return {
      config,
    };
  },
  methods: {
    callModalSignupConfirm(rowData) {
      this.$modal.changeToComponent(this.$modal.modalType.SignupConfirm, rowData);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/spa/components/board/signup-management/BoardSignupManagement.vue